import React, { useRef, useState } from "react";
import axios from "axios";
import "../css/pothole.css";
import pothole from "../assets/icons/pothole.png";
import homeIcon from "../assets/icons/thinkIcons/Home.png";
import { useNavigate } from "react-router-dom";
import { showSuccessToast, showErrorToast } from "../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";

const PinHolePrediction = () => {
  const [inputType, setInputType] = useState("Image");
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [resultImage, setResultImage] = useState(null);
  const resultRef = useRef(null); // 👈 Add this near other refs

  const [isUploading, setIsUploading] = useState(false);
  const [isPredicting, setIsPredicting] = useState(false);

  const navigate = useNavigate();

  const handleUpload = async (mode) => {
    if (!file) return;

    if (mode === "upload") setIsUploading(true);
    if (mode === "predict") setIsPredicting(true);

    const formData = new FormData();
    formData.append("file", file);

    const endpoint =
      inputType === "Video" ? "/pinhole/upload-video" : "/pinhole/upload";

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}${endpoint}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data?.output_image_url) {
        setResultImage(
          `${process.env.REACT_APP_SERVER_URL}${res.data.output_image_url}`
        );

        // Scroll only when prediction is complete
        if (mode === "predict") {
          setTimeout(() => {
            resultRef.current?.scrollIntoView({ behavior: "smooth" });
          }, 200);
        }
      }

      showSuccessToast(
        mode === "upload"
          ? "File Uploaded Successfully"
          : "Prediction Completed Successfully"
      );
    } catch (err) {
      console.error("Upload Error:", err);
      showErrorToast(mode === "upload" ? "Upload Failed" : "Prediction Failed");
    } finally {
      if (mode === "upload") setIsUploading(false);
      if (mode === "predict") setIsPredicting(false);
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="flex justify-end">
        <button
          className="flex items-center gap-2 border px-3 py-2 mb-2 rounded-full"
          onClick={() => navigate("/user/dashboard")}
        >
          <img src={homeIcon} alt="Home Icon" className="w-[18px] h-[18px]" />
          <span className="text-xs">Home</span>
        </button>
      </div>

      {/* Header Card */}
      <div className="card mb-4">
        <div className="card-body pothole-header d-flex align-items-center">
          <img
            src={pothole}
            alt="Pothole"
            className="rounded me-3"
            style={{ width: "80px", height: "80px", objectFit: "cover" }}
          />
          <div>
            <h6 className="mb-1 ">Pothole detection</h6>
            <p className="mb-0 text-muted">
              Automated Detection of Road Surface Damage
            </p>
          </div>
        </div>
      </div>

      <div className="pothole-body">
        <p className="fw-semibold">
          | Enter Pothole Image/ Video for detection
        </p>

        {/* Upload Section */}
        <div className="card pothole-upload mb-4 shadow-sm">
          <div className="card-body">
            {/* Centered Select Input */}
            <div className="row mb-3 justify-content-center">
              <div className="col-md-4 col-sm-12 text-center">
                <label htmlFor="inputType" className="form-label fw-semibold">
                  Select Input Type
                </label>
                <select
                  className="form-select text-center"
                  id="inputType"
                  value={inputType}
                  onChange={(e) => setInputType(e.target.value)}
                >
                  <option value="Image">Image</option>
                  <option value="Video">Video</option>
                </select>
              </div>
            </div>

            {/* Upload Box */}
            <div
              className="rounded p-4 pothole-box text-center d-flex flex-column align-items-center justify-content-center m-auto"
              onClick={() => fileInputRef.current.click()}
            >
              <i className="bi bi-cloud-upload fs-1 mb-3 text-secondary" />
              <label className="form-label fw-bold mb-2">
                Drag & Drop OR Click to Upload
              </label>
              <input
                type="file"
                accept={inputType === "Image" ? "image/*" : "video/*"}
                ref={fileInputRef}
                onChange={(e) => setFile(e.target.files[0])}
                style={{ display: "none" }}
              />
              <p className="text-muted">Supported formats: PNG, JPG, MP4</p>
              <button
                className="btn pothole-btn border mt-2 px-5"
                disabled={!file || isUploading}
                onClick={() => handleUpload("upload")}
              >
                {isUploading ? "Uploading..." : "Upload"}
              </button>
            </div>
          </div>
        </div>

        {/* Predict Button */}
        <div className="text-center mt-4">
          <button
            className="btn pothole-btn border px-5"
            disabled={!file || isPredicting}
            onClick={() => handleUpload("predict")}
          >
            {isPredicting ? "Predicting..." : "Predict & Deliver"}
          </button>
        </div>
      </div>

      {/* Prediction Result */}
      {/* {resultImage && (
        <div ref={resultRef} className="card shadow-sm mt-4">
          <div className="card-body">
            <h6 className="text-primary fw-semibold">Pothole prediction</h6>
            <p className="text-muted mb-2">
              Automated Detection of Road Surface Damage
            </p>
            <h6 className="fw-semibold text-success">Prediction Result</h6>

            <div className="d-flex justify-content-center h-50">
              {inputType === "Image" ? (
                <img
                  src={resultImage}
                  alt="Prediction"
                  className="img-fluid rounded border mt-3"
                />
              ) : (
                <video
                  src={resultImage}
                  controls
                  className="img-fluid rounded border mt-3"
                />
              )}
            </div>
          </div>
        </div>
      )} */}

      {/* Prediction Result */}
      {resultImage && (
        <div ref={resultRef} className="card shadow-sm mt-4">
          <div className="card-body">
            <h6 className="text-primary fw-semibold">Pothole prediction</h6>
            <p className="text-muted mb-2">
              Automated Detection of Road Surface Damage
            </p>
            <h6 className="fw-semibold text-success">Prediction Result</h6>

            <div className="d-flex justify-content-center h-50">
              {inputType === "Image" ? (
                <img
                  src={resultImage}
                  alt="Prediction"
                  className="img-fluid rounded border mt-3"
                />
              ) : (
                <a
                  href={resultImage}
                  download={`pothole_result_${Date.now()}.mp4`}
                  className="btn btn-success mt-3"
                >
                  Download Processed Video
                </a>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PinHolePrediction;
